import React from 'react';

export function InvoiceTitle() {
  return (
    <div 
      className="text-center mb-3"
      style={{
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
      }}
    >
      <div className="font-bold text-[16px] tracking-wide inline-block relative">
        CASH MEMO / BILL
        <span className="absolute left-0 right-0 -bottom-[6px] h-[2px] bg-black"></span>
      </div>
    </div>
  );
}

export default InvoiceTitle;
